import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { MOBILE_NAV_HEIGHT } from '@components/main-components/mobile-nav/constants';
import { prefetchQuery, WaveformExpandedPlayerDocument } from '@graphql/reactQuery';
import { usePrefetchTrackInView } from '@hooks/usePrefetchTracksInView';
import { useAudioController } from '@store/audio/AudioController';
import { setHideExpandedPlayer } from '@store/audio/AudioMeta';
import { ExpandedPlayer } from '../ExpandedPlayer';
import { FlexBetweenWrapper } from '../shared';
import { PlayerController } from './PlayerController';
import { SongInfo } from './SongInfo';
import { Timeline } from './Timeline';

export const MINIMIZED_PLAYER_HEIGHT = 56;

export const MinimizedPlayer = () => {
  const { activeTrackId, hideExpandedPlayer } = useAudioController();
  const openPlayer = () => {
    setHideExpandedPlayer(false);
  };
  const closePlayer = () => setHideExpandedPlayer(true);

  const {
    playerTrackInfo: { releaseInfo },
    inViewRef,
  } = usePrefetchTrackInView({
    trackId: activeTrackId,
  });

  const releaseId = releaseInfo?.id;

  React.useEffect(() => {
    if (!releaseId) return;

    prefetchQuery(WaveformExpandedPlayerDocument, {
      variables: {
        releaseId,
      },
      staleTime: Infinity,
    });
  }, [releaseId]);

  return (
    <>
      <ExpandedPlayer isOpen={!hideExpandedPlayer} closePlayer={closePlayer} />
      <MinimizedContainer onClick={openPlayer} ref={inViewRef}>
        <Timeline />
        <Wrapper>
          <SongInfo />
          <PlayerController />
        </Wrapper>
      </MinimizedContainer>
    </>
  );
};

const MinimizedContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  backgroundColor: '#000',
  zIndex: '$audioPlayerContainer',
  position: 'fixed',
  bottom: `calc(${MOBILE_NAV_HEIGHT}px + env(safe-area-inset-bottom))`,

  '@tablet': {
    display: 'none',
  },
});

const Wrapper = styled(FlexBetweenWrapper, {
  paddingLeft: 8,
  paddingRight: 16,
  gap: 16,
  height: MINIMIZED_PLAYER_HEIGHT,
});
